import { FreeMode } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import styled from 'styled-components'

import { Chip } from '../chip'

interface SlideFilterProps<T> {
  filterType: T
  filterList: { type: T; title: string }[]
  setFilterType: (type: T) => void
}

export function SlideFilter<T>({ filterType, filterList, setFilterType }: SlideFilterProps<T>) {
  return (
    <StyledSwiper autoHeight={true} freeMode={true} slidesPerView="auto" spaceBetween={8} modules={[FreeMode]}>
      {filterList.map(({ type, title }, index) => {
        const isActive = filterType === type

        const select = () => setFilterType(type)

        return (
          <SlideItem key={index}>
            <Chip $color={isActive ? 'black' : 'white'} onClick={select}>
              {title ?? '-'}
            </Chip>
          </SlideItem>
        )
      })}
    </StyledSwiper>
  )
}

const StyledSwiper = styled(Swiper)`
  margin: 0;
  padding: 0 16px;
`

const SlideItem = styled(SwiperSlide)`
  width: auto !important;
  height: 35px !important;
  line-height: 100%;
`
